const mascCNPJ = s => (s.length !== 14) ? s : (
  `${s.substr(0,2)}.${s.substr(2,3)}.${s.substr(5,3)}/${s.substr(8,4)}-${s.substr(12)}`
)

const mascCPF = s => (s.length !== 11) ? s : (
  `${s.substr(0,3)}.${s.substr(3,3)}.${s.substr(6,3)}-${s.substr(9)}`
)

const mascPIS = s => (s.length !== 11) ? s : (
  `${s.substr(0,3)}.${s.substr(3,5)}.${s.substr(8,2)}-${s.substr(10)}`
)

const mascCEP = s => (s.length !== 8) ? s : (
  `${s.substr(0,5)}-${s.substr(5)}`
)

const mascTelefone = s => {
  if (!s) return null;
  if (s.length == 8) return `${s.substr(0,4)}-${s.substr(4)}`;
  if (s.length == 9) return `${s.substr(0,5)}-${s.substr(5)}`;
  return s;
}

export { mascCNPJ, mascCPF, mascPIS, mascCEP, mascTelefone }
